import { toast } from 'sonner';
import { BASE_URL } from '../../constants/apiPaths';
import { auth, getAccessToken } from '../../firebase';
import axios from 'axios';

const getConfig = (token) => {
    return {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };
};

export const createEvent = async (event) => {
    try {
        const url = `${BASE_URL}/event`;

        const accessToken = await getAccessToken();

        const response = await axios.post(url, event, getConfig(accessToken));

        if (response.data.status === 'SUBMITTED') toast.success('An event has been successfully created');
        return response.data;
    } catch (error) {
        toast.error('Sorry unable to create an event.');
    }
};
